// extracted by mini-css-extract-plugin
export var divider = "_ym-0";